module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAABHklEQVR4Ae3MAUSdYRTH4efamJmBxbBJIBBAREFCABEKRAAEiAAFkCBAUAQIgRIgoCpQUEVRpFwqborSlROk+Lx6vwqU/g9wDj+fbF/7bcCiO6Fmy4x+P716P4y4FgWXxv2i/FodCmnH2pVcuxvxglvd8tOgKjJq/shuTuSZlR4qeiw7E6Xca5Jcm02RMPas8JlMZ25EEgAKn1OKa1QTZUIFF5b0qQCwIsqGElb9BTpF+VDSgQaYfncorKuwn3gcGXsEgKfbkVDUS10kDCO9UZGwwJVQPjUskqrsikwqnwl1pkQmlc+EKl0ik8pnwgIsZ1L5TBiEf6qZVC6z5xvQ4ly82YlGAJqtiTfZ9l9hHSZsqIlS6nbMG/Ldh93XHgCZzCt6xltSjAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/download.png
// module id = 414
// module chunks = 0